import { createContext, useContext } from 'react';
import { useGeoInfo } from '@alfa-bank/site-geo-info';
import { useForm, useField, useFormState } from 'react-final-form';
import type { FieldRenderProps, UseFieldConfig } from 'react-final-form';

import type { IGeo } from '../../models';

import type { IFormContext, TFields, TErrorFields } from './models';
export type { IFormContext } from './models';
// намерено передан any, чтобы не конфликтовать с useContext
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormContext = createContext({} as IFormContext<any, any>);

export const useFormContext = <T extends TFields, K extends TErrorFields<T>>() =>
    useContext<IFormContext<T & TFields, K>>(FormContext);

/** Хук для получения geo данных из GeoInfoProvider
 * @param ctx значение гео-данных если из GeoInfoProvider ничего не пришло
 * @default ctx { id: 21, remote: true, cityPath: 'test', regionId: 77, cityTitle: 'Москва' }
 */
export const useSmeGeoInfo = (ctx?: ReturnType<typeof useGeoInfo>) =>
    useGeoInfo(
        ctx || { id: 21, remote: true, cityPath: 'test', regionId: 77, cityTitle: 'Москва' }
    ) as IGeo;

const ERROR_MESSAGE = 'Виджет нужно обернуть в SmeForm';

/** Обертка для хука для useForm, чтобы в CS2 можно было использовать пресеты */
export function useFormSafe<T>() {
    try {
        return useForm<T>();
    } catch {
        console.error(ERROR_MESSAGE);

        return null;
    }
}

/** Обертка для хука для useField, чтобы в CS2 можно было использовать пресеты */
export function useFieldSafe<FieldValue = unknown, T extends HTMLElement = HTMLElement>(
    name: string,
    config?: UseFieldConfig<FieldValue>
): FieldRenderProps<FieldValue, T> | null {
    try {
        return useField(name, config);
    } catch {
        console.error(ERROR_MESSAGE);

        return null;
    }
}

/** Обертка для хука для useFormState, чтобы в CS2 можно было использовать пресеты */
export function useFormStateSafe<T extends Parameters<typeof useFormState>>(params?: T[0]) {
    try {
        return useFormState(params);
    } catch {
        console.error(ERROR_MESSAGE);

        return null;
    }
}
